import React, { useState, useEffect } from "react";
import CtaLayout from "./CtaLayout";
import "../../styles/common.css";
import "../../styles/cta.css";

function CtaNomal() {

  return (
    <>
      <CtaLayout title="Contact Us" lead="CONTACT">
        <div className='cta-box__text'>
          <h3>Please consult with us from the extraction of issues and the organization of website production purposes.</h3>
          <p>We welcome customers who are unsure of what to do for their first website production.<br />Leave everything to us, from extracting current issues, organizing the purpose of the site, and formulating the site concept. Of course, we will also propose site structure, design, and functionality to realize your web marketing strategy.</p>
        </div>
      </CtaLayout>
    </>
  );
}

export default CtaNomal;
